import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Conexao from '../../../providers/Conexao';
import Layout from '../../Layout';
import fontConfig from '../../../Componentes/FontConfig';
import { useLocation } from 'react-router-dom';
import { OverlayPanel } from 'primereact/overlaypanel';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { InputSwitch } from "primereact/inputswitch";
import { SpeedDial } from 'primereact/speeddial';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import BotaoEditar from '../../../Componentes/BotaoEditar';
import BotaoExcluir from '../../../Componentes/BotaoExcluir';
import SidebarClientes from './SidebarClientes';
import FormNovoCliente from './FormNovoCliente';
import UpdateButton from '../../../Componentes/UpdateButton';
import DeleteButton from '../../../Componentes/DeleteButton';
import InputTextTelefone from '../../../Componentes/InputTextTelefone';
import InputTextEmail from '../../../Componentes/InputTextEmail';
import { Password } from 'primereact/password';

export default function FormUsuariosCliente(props) {
    const toast = React.useRef(null); // Ref para o Toast
    const [fieldsFound, setFieldsFound] = useState([]);
    const {idempresa, idcliente} = props
    const carregadoClientes = useRef(false); // Evita múltiplas chamadas
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [usuarios, setUsuarios]= useState(props.usuarios);
    const {Conexao} =  props

    const [usuario, setUsuario]= useState([]);
    const [edicao, setEdicao]= useState(false);
    const [cadastro, setCadastro]= useState(false);
    const [senha, setSenha] = useState('');
    

    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        setUsuarios(props.usuarios)
    },[props.usuarios])

    useEffect(()=>{
        console.log(usuario)
    },[usuario])


useEffect(()=>{
       setCadastro(false)
       console.log(props)
    },[])
    



    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        nome: { value: '', matchMode: FilterMatchMode.CONTAINS },
        departamento: { value: '', matchMode: FilterMatchMode.EQUALS },
        email: { value: '', matchMode: FilterMatchMode.EQUALS }
    });
    

    const clearFilters = () => {
            setGlobalFilterValue('');
            setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            nome: { value: '', matchMode: FilterMatchMode.CONTAINS },
            departamento: { value: '', matchMode: FilterMatchMode.EQUALS },
            email: { value: '', matchMode: FilterMatchMode.EQUALS }
            });
            setFieldsFound([]); // Resetando os campos encontrados
        };

    

        const renderHeader = () => {
                return (
                    <div className="flex justify-content-between align-items-center" style={{paddingBottom : '10px', paddingTop : '10px', paddingLeft : '0px'}}>
                       
                        <div className="flex align-items-center gap-2">
                            <IconField iconPosition="left">
                                <InputIcon className="pi pi-search" />
                                <InputText 
                                    value={globalFilterValue} 
                                    onChange={onGlobalFilterChange} 
                                    placeholder="Pesquisa global" 
                                    tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                                />
                            </IconField>
                            <Button 
                                icon="pi pi-filter-slash" 
                                className="p-button-secondary p-button-sm" 
                                onClick={clearFilters} 
                                tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                            />
                            
                            <Button 
                                icon="pi pi-plus" 
                                className= "p-button-primary p-button-sm"                             
                                tooltip="Nova Licença" tooltipOptions={{ position: 'bottom' }}
                                onClick={()=>{
                                    setCadastro(true)
                                    setUsuario({
                                        idusuario : props.idusuario, 
                                        idempresa : props.idempresa, 
                                        idcliente : props.idcliente, 
                                        nomeCompleto: null,
                                        email: null,
                                        senha: gerarSenha(),
                                        departamento: null,
                                        telefoneContato: null,
                                        collector: "t",
                                        billing: "f",
                                        chamados: "f",
                                        suprimentos: "f",
                                        enviarSenha: "f"

                                    })
                                }}
                            />            
                        </div>
                        
                    </div>
                );
            };
            const onGlobalFilterChange = (e) => {
                const value = e.target.value;
                setGlobalFilterValue(value);
            
                setFilters(prevFilters => ({
                    ...prevFilters,
                    global: { value, matchMode: FilterMatchMode.CONTAINS }
                }));
            };
            const handleChange = (e) => {
                const { name, value } = e.target;
                setUsuario(prevState => ({
                    ...prevState,
                    [name]: value
                }));
            };

    const gerarSenha = () => {
        var stringAleatoria = '';
        var caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for (var i = 0; i < 4; i++) {
            stringAleatoria += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
        }
        
        caracteres = '0123456789';
        for (var i = 0; i < 4; i++) {
            stringAleatoria += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
        }
        return stringAleatoria
    };


    const insertAcessoCliente = () =>{
    
        
        Conexao.post('clientesController/insertAcessoCliente', {
           ...usuario, 
           nomeCompleto : usuario.nome
        }).then(response=>{
            if(response.status === 200 && response.data.status === 'OK'){              
               
                props.showMessageToast('success', 'Registro excluido com sucesso!')
                props.setUsuarios()
                setCadastro(false)
            }else{
                
                props.showMessageToast('warn', 'Não foi possível excluir!')

            }
        }).catch(error=>{
            setCadastro(false)
            props.showMessageToast('warn', 'Não foi possível excluir! Erro ao conectar o serviço remoto!')

        })
    }

    const deleteAcessoCliente = (idusuario, idempresa, idcliente, idacesso) =>{
    
        
        Conexao.post('clientesController/deleteAcessoCliente', {
           idusuario : idusuario, 
           idempresa : idempresa, 
           idcliente : idcliente, 
           idacesso : idacesso
        }).then(response=>{
            
            if(response.status === 200 && response.data.status === 'OK'){              
                
                props.deleteUser(usuarios.filter(user=>
                    user.idacesso !== idacesso
                ))

                props.showMessageToast('success', 'Registro excluido com sucesso!')
               
                setCadastro(false)

            }else{

                setCadastro(false)

                props.showMessageToast('warn', 'Não foi possível excluir!')

            }

        }).catch(error=>{
            
            setCadastro(false)
            props.showMessageToast('warn', 'Não foi possível excluir! Erro ao conectar o serviço remoto!')

        })
    }


    const editarAcessoCliente = () =>{
    
        
        Conexao.post('clientesController/editarAcessoCliente', {
           idusuario : usuario.idusuario, 
           idempresa : usuario.idempresa, 
           idcliente : usuario.idcliente, 
           idacesso : usuario.idacesso,
           ...usuario, 
           nomeCompleto : usuario.nome, 
           senha: usuario.senha, 
           telefoneContato : usuario.telefonecontato
        }).then(response=>{
            
            if(response.status === 200 && response.data.status === 'OK'){              
                /*
                props.deleteUser(usuarios.filter(user=>
                    user.idacesso !== usuario.idusuario
                ))
                    */

                props.showMessageToast('success', 'Registro alterado com sucesso!')
               
                setCadastro(false)
            }else{
                setCadastro(false)
                props.showMessageToast('warn', 'Não foi possível alterar!')

            }
        }).catch(error=>{
            setCadastro(false)
            props.showMessageToast('warn', 'Não foi possível alterar! Erro ao conectar o serviço remoto!')

        })
    }



    return <div>
                {(!edicao && !cadastro) ? <DataTable
                    value={usuarios}
                    header={renderHeader()}
                    paginator                 
                    rows={15} // Número de itens por página
                    rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                    responsiveLayout="scroll"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                    tableStyle={{ minWidth: '35rem', fontSize : '10px' }}
                    filters={filters}
                    globalFilterFields={['nome', 'email', 'departamento']}
                    bodyStyle={{fontSize : '10px'}}                            
                    rowClassName={rowData => rowData.ativo === 'f' ? 'row-inativo' : ''}
                >
                     <Column 
                        bodyStyle={{ fontSize: '11px' , width : '15%', paddingTop:'8px', paddingBottom: '8px' }} 
                        headerStyle={{ fontSize:'10px' }} 
                        field="nome" 
                        header="Nome Usuário" 
                        name="nome" 
                        body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                        sortable 
                            />
                    <Column 
                        bodyStyle={{ fontSize: '11px' , width : '20%', paddingTop:'8px', paddingBottom: '8px' }} 
                        headerStyle={{ fontSize:'10px' }} 
                        field="email" 
                        header="Email" 
                        name="email" 
                        body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                        sortable 
                        />
                    <Column 
                        bodyStyle={{ fontSize: '11px' , width : '15%', paddingTop:'8px', paddingBottom: '8px' }} 
                        headerStyle={{ fontSize:'10px' }} 
                        field="departamento" 
                        header="Departamento" 
                        name="departamento" 
                        body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                        sortable 
                         />
                    <Column 
                            bodyStyle={{ fontSize: '11px' , width : '3%', paddingTop:'4px', paddingBottom: '4px' , textAlign:'center' }} 
                            headerStyle={{ fontSize:'10px', paddingTop:'8px', paddingBottom: '8px',  }} 
                            header="Editar"
                            body={(row)=> loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : 
                            <UpdateButton style={{padding : '2px'}} className='w-full' onClick = {()=>{
                                setEdicao(true)
                                setUsuario(row)
                            }}/>}                         
                        />
    
                    <Column 
                            bodyStyle={{ fontSize: '11px' , width : '3%', paddingTop:'4px', paddingBottom: '4px', textAlign:'center' }} 
                            headerStyle={{ fontSize:'10px', paddingTop:'8px', paddingBottom: '8px',  }} 
                            header="Editar"
                            body={(row) => loading ? 
                                        <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> 
                                            : 
                                        <DeleteButton severity="danger" style={{padding : '2px'}} className='w-full' onClick = {()=>{
                                            confirmDialog({
                                            message: 'Deseja cancelar?',
                                            header: 'Confirmação',
                                            icon: 'pi pi-exclamation-triangle',
                                            acceptLabel: 'Sim',
                                            rejectLabel: 'Não',
                                            accept: () => {
                                                deleteAcessoCliente(row.idusuario, row.idempresa, row.idcliente, row.idacesso)
                                            }
                                        }) 
                                        }}/>}                         
                        />

                </DataTable> : <div>
                                <div className="flex flex-wrap gap-0 "  >
                                    {/* Exibindo informações da cliente */}
                                    <div className="col-12 md:col-5">
                                        <span className="font-medium text-sm">Nome do Usuário</span>
                                        <InputText           
                                            value = {usuario.nome}                                
                                            name="nome"
                                            onChange={handleChange}
                                            className="w-full mt-2"
                                        />
                                    </div>

                                    <div className="col-12 md:col-4">
                                        <span className="font-medium text-sm">Departamento</span>
                                        <InputText           
                                            value = {usuario.departamento}                                
                                            name="departamento"
                                            onChange={handleChange}
                                            className="w-full mt-2"
                                        />
                                    </div>
                                    <div className="col-12 md:col-3">
                                        <span className="font-medium text-sm">Telefone</span>
                                        <InputTextTelefone           
                                            value = {usuario.telefonecontato}                                
                                            name="telefonecontato"
                                            onChange={handleChange}
                                            className="w-full mt-2"
                                        />
                                    </div>
                                    <div className="col-12 md:col-9">
                                        <span className="font-medium text-sm">Email</span>
                                        <InputTextEmail           
                                            value = {usuario.email}                                
                                            name="email"
                                            onChange={handleChange}
                                            className="w-full mt-2"
                                        />
                                    </div>
                                    <div className="col-12 md:col-3">
                                        <span className="font-medium text-sm">Senha</span>
                                        <InputTextEmail 
                                               
                                            value = {usuario.senha}                                
                                            name="senha"
                                            onChange={handleChange}
                                            className="w-full mt-2"
                                        />
                                    </div>
                                </div>
                                <div className="mt-4 flex justify-content-end mt-2">
                                    <Button disabled={props.loading} severity="secondary" className="mt-2 mr-2" label="Cancelar" icon="pi pi-times" onClick={() => {
                                            confirmDialog({
                                            message: 'Deseja cancelar?',
                                            header: 'Confirmação',
                                            icon: 'pi pi-exclamation-triangle',
                                            acceptLabel: 'Sim',
                                            rejectLabel: 'Não',
                                            accept: () => {
                                                setUsuario([])
                                                setEdicao(false)
                                                setCadastro(false)
                                            }
                                        });
                                    }} />
                                    <Button disabled={props.loading} severity="primary" className="mt-2 mr-2" label="Salvar" icon="pi pi-save" onClick={() => {
                                            
                                            confirmDialog({
                                            message: 'Confirma a Inclusão/Alteração deste usuário?',
                                            header: 'Confirmação',
                                            icon: 'pi pi-exclamation-triangle',
                                            acceptLabel: 'Sim',
                                            rejectLabel: 'Não',
                                            accept: () => {
                                               if(cadastro && !edicao){
                                                    insertAcessoCliente()
                                               }else if(!cadastro && edicao){
                                                alert('teste')
                                                    editarAcessoCliente()
                                               }
                                            }
                                        });
                                    }} />
                                </div>
                    </div>}
    </div>

}